// Runtime bucket-switch anchors for cross-bucket tour preludes.

import type { BucketId } from "@/components/shell/modes/bucketsRegistry";

export const FIREFLY_BUCKET_SWITCHER_TARGET_ID = "bucket-switcher";

export function fireflyBucketNavTargetId(bucketId: BucketId): string {
  return `bucket-nav-${bucketId}`;
}

export function isFireflyBucketNavTarget(targetId: string): boolean {
  return targetId.startsWith("bucket-nav-");
}

export function fireflyBucketIdFromNavTarget(targetId: string): BucketId | null {
  if (!isFireflyBucketNavTarget(targetId)) return null;
  const bucketId = targetId.slice("bucket-nav-".length);
  return bucketId ? (bucketId as BucketId) : null;
}
